<script>
import NuttremaIndexList from 'components/ui/list/nuttrema-index-list';
import NuttremaIndexListItem from './cmpt-allergens-index-list-item';

export default {
  mixins: [NuttremaIndexList],
  name: 'allergens-index-list',
  components: {
    NuttremaIndexListItem,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/workspace/allergens/list/cmpt-allergens-index-list.vue